import { Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { RegionDetailContext } from "contexts/LocationContexts/RegionDetailContext";
import { useGetRegionDetailQuery } from "store/services/LocationsApi/regionApi";
import RegionDetailTabs from "./regionComponents/RegionDetailTabs";
import RegionBasicDetails from "./regionComponents/RegionBasicDetails";
// import { EditOutlined } from "@mui/icons-material";

const RegionDetailScreen = () => {
  const { id } = useParams();
  const breadcrumbs = [
    {
      title: "Province",
      path: "/app/crm/region/list",
    },
    { title: "Province Detail" },
  ];

  const {
    data: regionDetail,
    isLoading: loadingRegion,
    error,
  } = useGetRegionDetailQuery(id);

  const PageActions = () => (
    <Link to={`/app/crm/region/${id}/edit`} state={{ from: "detail" }}>
      {/* <Button variant="contained" startIcon={<EditOutlined />}>
        Edit
      </Button> */}
    </Link>
  );

  useAppMeta("Province Detail");

  return (
    <RegionDetailContext.Provider value={{ regionDetail, loadingRegion }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingRegion}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <RegionBasicDetails />
          <Divider />

          <RegionDetailTabs />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </RegionDetailContext.Provider>
  );
};

export default RegionDetailScreen;
